import { Dialog } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import wxPopup from './plugin/index';
import Vue from 'vue';
Vue.use(Dialog).use(wxPopup);

const downLoadUrl =
  'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
const messageAlert = () => {
  Dialog.confirm({
    title: '友情提示',
    message: '请在上游新闻App进行报名',
    confirmButtonText: '还没装？一步安装',
    cancelButtonText: '我已安装过',
    closeOnClickOverlay: true,
  })
    .then(() => {
      window.location.href = downLoadUrl;
    })
    .catch(() => {
      if (isWeiXin() === true) {
        Vue.prototype.$wxPopup();
      } else {
        window.location.href =
          'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
      }
    });
};

export default {
  path: '/2019TheEighthChinaInnovationCompetition',
  name: 'TheEighthChinaInnovationCompetition',
  component: () => import('./Home.vue'),
  redirect: '',
  meta: {
    title: '重庆·大足锻打刀具创意设计专业赛',
  },
  children: [
    {
      path: 'networkVote',
      name: 'networkVote',
      redirect: 'networkVote/list',
      meta: {
        title: '重庆·大足锻打刀具创意设计专业赛',
      },
      component: () => import('./networkVote/NetWorkVoteHome.vue'),
      children: [
        {
          path: 'list',
          component: () => import('./networkVote/List.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
        },
        {
          path: 'rules',
          component: () => import('./networkVote/Rules.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
        },
        {
          path: 'detail',
          component: () => import('./networkVote/Detail.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
        },
      ],
    },
    {
      path: 'theFutureTool',
      name: 'theFutureTool',
      redirect: 'theFutureTool/list',
      meta: {
        title: '重庆·大足锻打刀具创意设计专业赛',
      },
      component: () => import('./theFutureTool/TheFutureToolHome.vue'),
      children: [
        {
          path: 'list',
          component: () => import('./theFutureTool/List.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
        },
        {
          path: 'rules',
          component: () => import('./theFutureTool/Rules.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
        },
        {
          path: 'apply',
          component: () => import('./theFutureTool/Apply.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
          beforeEnter: (to: any, from: any, next: any) => {
            if (window.udid === '') {
              messageAlert();
              return;
            } else {
              next();
            }
          },
        },
        {
          path: 'detail',
          component: () => import('./theFutureTool/Detail.vue'),
          meta: {
            title: '重庆·大足锻打刀具创意设计专业赛',
          },
        },
      ],
    },
  ],
};
